













import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {},
})
export default class HandlePostChat extends Vue {
  selectEmoji(emoji: any) {
    this.$emit("select-emoji", emoji.data);
  }
  get i18n() {
    const i18n = {
      search: "emojiを検索...",
      categories: {
        Activity: "アクティビティ",
        Flags: "フラッグ",
        Foods: "食事",
        Frequently: "よく使う",
        Objects: "もの",
        Nature: "自然",
        Peoples: "人物",
        Symbols: "シンボル",
        Places: "場所",
      },
    };
    return i18n;
  }
}
